import React from 'react'
import { useHistory } from 'react-router-dom'
import { useMe } from '../../../contexts/me'
import { usePage } from '../../../contexts/page'
import HeaderDashboard from '../../dashboard/header-dashboard'
import SidebarDashboard from '../../dashboard/sidebar-dashboard'
import Icon from '../../icon'
import { If } from '../../if/if'
import Loading from '../../loading'

import { Container, Main, Title } from './styles'

const DashboardLayout = ({ children }: any) => {
  const { header } = usePage()
  const { me } = useMe()
  const history = useHistory()

  const handleRedirect = () => {
    if (header.goTo) {
      history.push(header.goTo)
    }
  }

  if (!me) <Loading />

  return (
    <Container>
      <HeaderDashboard />
      <SidebarDashboard />
      <Main>
        <Title hasGoTo={!!header.goTo} onClick={handleRedirect}>
          <If condition={header.title && !!header.goTo}>
            <Icon name="arrow-left" />
          </If>
          {header.title}
        </Title>
        { children }
      </Main>
    </Container>
  )
}

export default DashboardLayout
